var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTruckShop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 133.688,
    height: 113.674,
    viewBox: "0 0 133.688 113.674",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2423.243 -5592.05)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11.482,
    cy: 11.482,
    r: 11.482,
    transform: "translate(2518.037 5682.259)",
    stroke: "#0c9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.482,
    cy: 7.482,
    r: 7.482,
    transform: "translate(2522.037 5686.259)",
    stroke: "#0c9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.482,
    cy: 11.482,
    r: 11.482,
    transform: "translate(2443.261 5682.259)",
    stroke: "#0c9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.482,
    cy: 7.482,
    r: 7.482,
    transform: "translate(2447.262 5686.259)",
    stroke: "#0c9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2522.354 5624.14l-13.766-.147V5694h9.449m22.963 0h8.5a2.966 2.966 0 002.967-2.966v-36.272a2.973 2.973 0 00-.655-1.859L2534.2 5631m-67.99 63h42.377v-90.656a2.966 2.966 0 00-2.966-2.966h-78.912a2.966 2.966 0 00-2.966 2.966v87.69a2.966 2.966 0 002.966 2.966h16.569",
    stroke: "#0c9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2448.155 5645.632h36.038v20.234a.979.979 0 01-.979.979h-34.08a.979.979 0 01-.979-.979v-20.234h0z",
    stroke: "#0c9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 43.659,
    height: 8.431,
    rx: 0.979,
    transform: "translate(2444.335 5637.201)",
    stroke: "#0c9"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0c9",
    d: "M2461.477 5637.201v8.431m9.377-8.431v8.431m-8.413 0v20.877m7.466-20.877v20.877m-4.844-29.309h-6.669a1.093 1.093 0 01-.853-.515c-3.373-6.178-.458-9.153 3.553-9.153 2.45 0 4.491 5.236 4.94 8.484a1.016 1.016 0 01-.971 1.184zm2.126 0h6.669a1.09 1.09 0 00.853-.515c3.374-6.178.459-9.153-3.553-9.153-2.45 0-4.491 5.236-4.94 8.484a1.016 1.016 0 00.971 1.184zm41.398 13.449h41.741m-25.558-24.212v24.213"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.227,
    cy: 19.227,
    r: 19.227,
    transform: "translate(2517.977 5592.55)",
    stroke: "#6e7e9d"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#6e7e9d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.33 24.699h23.261v.083a2.211 2.211 0 01-2.211 2.211h-18.839a2.211 2.211 0 01-2.211-2.211v-.083h0zm10.018.813h2.933m-10.28-13.051h17.922a.978.978 0 01.978.978v11.26h0-19.878 0v-11.26a.978.978 0 01.978-.978z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.737 14.275h16.488v10.424h-16.488z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruckShop);
export default __webpack_public_path__ + "static/media/truckShop.d83900fad49eeccfdd247cb48bb15b93.svg";
export { ForwardRef as ReactComponent };